import React from 'react';
import { compose } from 'ramda';
import styleFile from './MBoxBanner.js'
import moment from 'moment';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';

const MBoxbanner = class MBoxbanner extends React.Component {
  static displayName = 'MBoxbanner';

  retrieveParams = (url) => {
    let params = {};
    let parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  dataDistributionBuild = (reservation, reservationRequest) => {
    let roomArray = [];
    reservation.get('blocks').forEach((block) => {
      const reservationRequestBlock = reservationRequest.getIn(['blocks', block.get('idx') - 1]);

      const adults = reservationRequestBlock.get('adults');
      const childs = reservationRequestBlock.get('childs');

      roomArray.push(adults + '~~' + childs);
    });
    return roomArray.join('::')
  };

  createScript = () => new Promise((resolve, reject) => {
    const { hotelInfo, reservation, langCode, urlFlyHotel, reservationRequest, mboxScript } = this.props.config;
    const urlFlyParams = this.retrieveParams(urlFlyHotel);
    const dataDistributionDetail = this.dataDistributionBuild(reservation, reservationRequest);
    const dateFormat = 'DD/MM/YYYY';
    const scriptMBoxBanner = document.createElement('script');

    scriptMBoxBanner.setAttribute('id', 'mBoxWidgetTrc');//Enviado por Travel Compositor. Obligatorio
    scriptMBoxBanner.setAttribute('data-client-id', urlFlyParams.microsite);//Enviado por Travel Compositor. Obligatorio
    urlFlyParams.agency && scriptMBoxBanner.setAttribute('data-agency-id', urlFlyParams.agency);
    scriptMBoxBanner.setAttribute('data-auto-open', true);
    scriptMBoxBanner.setAttribute('data-trip-language', langCode.toUpperCase() || 'EN');
    scriptMBoxBanner.setAttribute('data-trip-type', 'ONLY_HOTEL');//Valores válidos "ONLY_FLIGHT", "ONLY_HOTEL", "HOLIDAYS". Obligatorio
    scriptMBoxBanner.setAttribute('data-distribution', dataDistributionDetail);//Distribución de reserva y datos pasajero. Obligatorio
    scriptMBoxBanner.setAttribute('data-booking-reference', reservation.get('tracking_id'));//Optativo
    scriptMBoxBanner.setAttribute('data-trip-start-date', moment(reservation.get('checkin'), 'YYYY-MM-DD').format(dateFormat));//Obligatorio
    scriptMBoxBanner.setAttribute('data-trip-end-date', moment(reservation.get('checkout'), 'YYYY-MM-DD').format(dateFormat));//Obligatorio
    scriptMBoxBanner.setAttribute('data-hotel-name', hotelInfo.get('name'));//Nombre del alojamiento. Obligatorio
    scriptMBoxBanner.setAttribute('data-hotel-latitude', parseFloat(hotelInfo.get('latitude')));//Latitud del alojamiento. Obligatorio
    scriptMBoxBanner.setAttribute('data-hotel-longitude', parseFloat(hotelInfo.get('longitude')));//Longitud del alojamiento. Obligatorio

    mboxScript && scriptMBoxBanner.setAttribute('src', mboxScript);

    document.head.appendChild(scriptMBoxBanner);

    scriptMBoxBanner.addEventListener('load', function () {
      resolve();
    });
    scriptMBoxBanner.addEventListener('error', function (e) {
      reject(e);
    });

  });

  doLoad = () => {
    let resolver;
    const timeout = new Promise((resolve) => {
      resolver = resolve;
    });
    setTimeout(() => {
      resolver();
    }, 3000);

    Promise.all([this.createScript(), timeout]).then(() => {
      window.buildMbox();
      window.addMBoxListener();
      console.error('loaded');
    }).catch(error => {
      console.error(error);
    });
  };

  componentDidMount = () => {
    this.doLoad();
  };

  render() {

    const { classes } = this.props.theme.styles;
    return (
      <div className={classes.confirmationContainer}>
        <div className={classes.confirmationBox}>
          <div id="mbox-widget" className={classes.mBoxContainer}></div>
        </div>
      </div>
    );
  }
};

export default compose(
  PropertyManager([
    'reservation',
    'hotelInfo',
    'langCode',
    'urlFlyHotel',
    'reservationRequest',
    'mboxScript'
  ]),
  withThemeJSS({ styleFile, link: true, displayName: 'MBoxbanner' })
)(MBoxbanner);